import i18n from "@/i18n";

export const computedStatusText = (update) => {
  switch (update) {
    case 1:
      return i18n.t("uploadStatus.pending");
    case 2:
      return i18n.t("uploadStatus.downloading");
    case 3:
      return i18n.t("uploadStatus.error");
    case 4:
      return i18n.t("uploadStatus.success");
    default:
      return i18n.t("uploadStatus.upToDate");
  }

  // switch (update) {
  //   case 1:
  //     return "Pending Download";
  //   case 2:
  //     return "Downloading Firmware";
  //   case 3:
  //     return "Download Error";
  //   case 4:
  //     return "Download Succeeded";
  //   default:
  //     return "Up to date";
  // }
};

export const computedStatusColor = (update) => {
  switch (update) {
    case 1:
      return "warning";
    case 2:
      return "success";
    case 3:
      return "danger";
    case 4:
      return "danger";
    default:
      return "accent lighten-4";
  }
};

export const computedStatusDld = (update) => {
  switch (update) {
    case 2:
      return true;
    default:
      return false;
  }
};
